import React from 'react';
import classnames from 'classnames';

import { FlexRow, FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import FormattedCurrencyContainer from '../../../../../components/formatted-currency/container';
import { useAnalyticsLicenseData } from '../../hooks/use-analytics-license-data';

import messages from './messages';
import styles from './style.module.less';

export const SubscriptionCardAnalyticsLicenseInfo = () => {
  const { includedLicenses, additionalLicenses, additionalLicensesCost } = useAnalyticsLicenseData();

  return (
    <FlexColumn>
      <Text textType={TextType.H4} value={messages.analyticsLicenses} />
      <FlexRow className={styles['new-info-row']}>
        <Text textType={TextType.Paragraph} value={messages.includedAnalyticsLicenses} />
        <Text textType={TextType.Paragraph} value={includedLicenses} />
      </FlexRow>
      <FlexRow className={classnames(styles['plan-info'], styles['new-info-row'])}>
        <FlexRow className={styles['with-count']}>
          <Text textType={TextType.Paragraph} value={messages.additionalAnalyticsLicenses} />
          <Text className={styles.count} textType={TextType.Paragraph} value={additionalLicenses} />
        </FlexRow>
        <div className={styles['plan-info-cost']}>
          <FormattedCurrencyContainer currencyCode={additionalLicensesCost.code} fractionDigits={2} value={additionalLicensesCost.value} />
        </div>
      </FlexRow>
    </FlexColumn>
  );
};
